<template>
  <div class="form-generator__field-warnings">
    <p
      v-for="(text, index) in warnings"
      :key="index"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
export default {
  name: 'InputWarnings',

  props: {
    warnings: VueTypes.arrayOf(String)
  }
}
</script>

<style lang="scss">
.form-generator__field-warnings {
  @include text-label;

  color: $red;
}
</style>
